/*
 * Teads Studio tracking pixels, from "Miele DACH AR - TOOLKIT.csv".
 * One Studio creative per market; each user action fires a GET to the
 * Studio tracker with the action's name. Endpoint, ids and query layout are
 * verbatim from the toolkit links - only the timestamp is per hit.
 */
import { LOCALE } from '../locales';

// market -> Studio creative ids (toolkit rows 5-7). The CH creative covers
// all three Swiss languages (its creative id is marked "(IT)" in the CSV).
const MARKETS = {
    DE: { studioCid: '6753877077383787', gid: '1482656', cid: '1809701' },
    AT: { studioCid: '6753877077383789', gid: '1482659', cid: '1809709' },
    CH: { studioCid: '6753877077383794', gid: '1482666', cid: '1809713' },
};

// locale path prefix -> market; /en is internal testing and reports into DE.
const MARKET_BY_LOCALE = {
    'de': 'DE',
    'at': 'AT',
    'ch-de': 'CH',
    'ch-fr': 'CH',
    'ch-it': 'CH',
    'en': 'DE',
};

// Action names, verbatim from the toolkit's Actions rows.
export const TRACK = {
    AD_PAN: 'AD_Pan',
    AD_POT: 'AD_Pot',
    CTA: 'CTA',
    AR: 'AR',
    INGREDIENTS: 'Ingredients',
    AR_STOVE: 'AR_Stove',
    AR_TABLE: 'AR_Table',
    AR_BACK: 'AR_Back',
    AR_RESTART: 'AR_Restart',
    AR_PHOTO: 'AR_Photo',
    AR_SHARE: 'AR_Share',
    AR_CLOSE: 'AR_Close',
};

export function track(action) {
    const market = MARKETS[MARKET_BY_LOCALE[LOCALE.code]] || MARKETS.DE;
    const url = 'https://studio-t.teads.tv/track'
        + '?action=' + encodeURIComponent('studio_#' + action)
        + '&studio_cid=' + market.studioCid
        + '&referer=&ts=' + Date.now()
        + '&studio_canvas=' + encodeURIComponent('Main canvas')
        + '&studio_segment=' + encodeURIComponent('Default segment')
        + '&gid=' + market.gid
        + '&cid=' + market.cid
        + '&pid=1&env=js-web&slot=native';

    // keepalive lets the hit survive an immediate navigation (the CTA opens
    // the shop, AR_Back reloads the page); Image() is the fallback. A hit can
    // always be lost - ad blockers kill studio-t.teads.tv with
    // ERR_BLOCKED_BY_CLIENT - and that must never surface as an app error,
    // hence the swallowed rejection.
    try {
        fetch(url, { method: 'GET', mode: 'no-cors', keepalive: true })
            .catch(() => { /* blocked or offline - nothing to do */ });
    } catch (error) {
        new Image().src = url;
    }
}
